/* La Cactus — revelado al hacer scroll. Cárgalo en theme.liquid (ver README). */
document.addEventListener('DOMContentLoaded', function () {
  var els = document.querySelectorAll('.cc-reveal');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (el) { el.classList.add('cc-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('cc-in'); io.unobserve(e.target); }
    });
  }, { threshold: 0.1 });
  els.forEach(function (el) { io.observe(el); });
});